import { createRouter } from '@tanstack/react-router';

import { routeTree } from '@/generated/routeTree.gen';
import { queryClient } from '@/queryClient';
import { authClient } from '@/services/auth';
import { RouteError } from '@/ui/shared/RouteError';
import { RoutePending } from '@/ui/shared/RoutePending';

export const router = createRouter({
  routeTree,
  // The live auth client, not a snapshot: guards run outside React and must observe the same
  // session object the components do (HS-859). The query client rides along so a data-screen
  // loader can prefetch into the very cache the components read (HS-869).
  context: { auth: authClient, queryClient },
  defaultPreload: 'intent',
  // Both defaults are load-bearing, not cosmetic: TanStack Router wraps a match in `<Suspense>`
  // only when a pending component exists, and in a `CatchBoundary` only when an error component
  // does. `@smartsash/data-screen` reads every list with `useSuspenseQuery`, so without these a
  // slow screen has nothing to suspend to and a failed one (a 403 on a list) takes the app down.
  defaultPendingComponent: RoutePending,
  defaultErrorComponent: RouteError,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
